import { FC } from "react";

import { NOTIFICATION_TYPES } from "shared/lib/constants/notifications";
import { NotificationCalendarInviteReceived } from "@/modules/notifications/notification/types/calendar-invite-received";

import { NotificationEmailOpened } from "./types/email-opened";
import { NotificationMissedCall } from "./types/missed-call";
import { NotificationMeetingQualified } from "./types/meeting-qualified";
import { NotificationMeetingUnqualified } from "./types/meeting-unqualified";
import { NotificationMeetingRescheduled } from "./types/meeting-rescheduled";
import { NotificationMeetingCanceled } from "./types/meeting-canceled";
import { NotificationMeetingNoShow } from "./types/meeting-no-show";
import { NotificationEmailReceived } from "./types/email-received";
import { NotificationColdOutreachEmailResponded } from "./types/cold-outreach-email-responded";
import { NotificationI } from "@/interfaces/notification";
import { DISPOSITIONS } from "shared/lib/constants/dispositions";
import { NotificationExclusiveListReceived } from "@/modules/notifications/notification/types/exclusive-list-received";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

export type NotificationPropsI = NotificationI & PropsWithClassNameI;

export const Notification: FC<NotificationPropsI> = (props) => {
  const { notification_type, meeting_feedback } = props || {};

  switch (notification_type) {
    case NOTIFICATION_TYPES.EMAIL_OPENED:
      return <NotificationEmailOpened {...props} />;
    case NOTIFICATION_TYPES.EMAIL_RECEIVED:
      return <NotificationEmailReceived {...props} />;
    case NOTIFICATION_TYPES.MISSED_CALL:
      return <NotificationMissedCall {...props} />;
    case NOTIFICATION_TYPES.LIST_RECEIVED:
      return <NotificationExclusiveListReceived {...props} />;
    case NOTIFICATION_TYPES.MEETING:
      switch (meeting_feedback) {
        case DISPOSITIONS.MEETING_QUALIFIED:
          return <NotificationMeetingQualified {...props} />;
        case DISPOSITIONS.MEETING_NOT_QUALIFIED:
          return <NotificationMeetingUnqualified {...props} />;
        case DISPOSITIONS.MEETING_RESCHEDULED:
          return <NotificationMeetingRescheduled {...props} />;
        case DISPOSITIONS.CANCELLED_MEETING:
          return <NotificationMeetingCanceled {...props} />;
        case DISPOSITIONS.MEETING_NO_SHOW:
          return <NotificationMeetingNoShow {...props} />;
      }
      break;
    case NOTIFICATION_TYPES.COLD_OUTREACH_EMAIL_RESPONDED:
      return <NotificationColdOutreachEmailResponded {...props} />;
    case NOTIFICATION_TYPES.CALENDAR_INVITE_RECEIVED:
      return <NotificationCalendarInviteReceived {...props} />;
  }

  return null;
};
